module.exports = __webpack_public_path__ + "img/130020.fb944b67.png";